export default __webpack_public_path__ + "static/media/tiktokDesk.c03b1a8b.svg";